import { RestClient } from "./restClient";
import { RealtimeClient } from "./RealtimeClient";

export class ListCategoryService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	getAll(callback) {
		const url = "/ecosystem/api/listCategories";
		this._restClient.exec_get(url, callback);
	}

	getListCategory(categoryId, callback) {
		const url = `/ecosystem/api/listCategories/${categoryId}`;
		this._restClient.exec_get(url, callback);
	}

	create(name, callback) {
		const url = "/ecosystem/api/listCategories";
		const body = JSON.stringify({
			name
		});
		this._restClient.exec_post(url, body, callback);
	}

	update(id, name, callback) {
		const url = `/ecosystem/api/listCategories/${id}`;
		const body = JSON.stringify({
			name
		});
		this._restClient.exec_put(url, body, callback);
	}

	delete(id, callback) {
		const url = `/ecosystem/api/listCategories/${id}`;

		this._restClient.exec_delete(url, callback);
	}

	streamAll(callback) {
		const args = {
			filterType: "all"
		};
		return this._rc.subscribe("ecosystem", "/listCategories", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}
}
